const whatYouGet = document.getElementById('whatyoullget');

let variantId = null;

subscribe(PUB_SUB_EVENTS.variantChange, (context) => {

    // prevent unnecessary ui changes from abandoned selections
    if (variantId === context.data.variant.id) return;
    variantId = context.data.variant.id;

    const url = `${whatYouGet.dataset.url}?variant=${context.data.variant.id}&section_id=${whatYouGet.dataset.sectionId}`;
    fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');

            const whatYouGetSource = html.getElementById('whatyoullget');
            const whatYouGetDestination = document.getElementById('whatyoullget');
            if (whatYouGetDestination) {
                whatYouGetDestination.innerHTML = whatYouGetSource?.innerHTML ?? '';
            }
        })
});